export const path = {
	path: "M2.5,2.5L202.4,145c2.3,1.7,5.4,1.7,7.7,0l49.3-35.1c2.3-1.7,5.4-1.7,7.7,0l258,183.8c2.3,1.7,5.4,1.7,7.7,0l154.6-110.1c2.3-1.7,5.4-1.7,7.7,0l38.4,27.4c2.3,1.7,5.4,1.7,7.7,0l34.6-24.6c2.3-1.7,5.4-1.7,7.7,0l237.3,169.1c3.7,2.7,3.7,8.2,0,10.9L870.2,473.7c-3.7,2.7-3.7,8.2,0,10.9l348,247.9c2.3,1.7,5.4,1.7,7.7,0l73.5-52.4c2.3-1.7,5.4-1.7,7.7,0l112.9,80.4c2.3,1.7,5.4,1.7,7.7,0l513.2-365.7",
	poiData: [
		// Strategy
		{
			xPosition: 264,
			yPosition: 111,
			angle: 325,
			lineLength: 140,
			icon: (
				<>
					<g clipPath="url(##strategy-clip-path)">
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							fill="url(#strategy-gradient)"
							stroke="url(#strategy-gradient)"
							className="cls-1"
							d="M100,0C44.86,0,0,44.86,0,100s44.86,100,100,100,100-44.86,100-100S155.14,0,100,0ZM100,196.86c-53.41,0-96.86-43.45-96.86-96.86S46.59,3.14,100,3.14s96.86,43.45,96.86,96.86-43.45,96.86-96.86,96.86Z"
						/>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							fill="url(#strategy-gradient)"
							stroke="url(#strategy-gradient)"
							className="cls-1"
							d="M111.57,143.55c2.79-2.89,4.51-6.82,4.51-11.14,0-8.87-7.21-16.08-16.08-16.08s-16.08,7.21-16.08,16.08c0,4.33,1.72,8.25,4.51,11.14-5.53,2.73-9.36,8.41-9.36,14.98v9.44c0,.87.7,1.57,1.57,1.57h38.71c.87,0,1.57-.7,1.57-1.57v-9.44c0-6.57-3.83-12.26-9.36-14.98ZM117.79,166.4h-35.58v-7.87c0-5.84,3.72-10.82,8.91-12.73,2.55,1.69,5.6,2.68,8.88,2.68s6.33-.99,8.88-2.68c5.19,1.91,8.91,6.88,8.91,12.73v7.87ZM87.06,132.4c0-7.14,5.81-12.94,12.94-12.94s12.94,5.81,12.94,12.94-5.81,12.94-12.94,12.94-12.94-5.81-12.94-12.94Z"
						/>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							fill="url(#strategy-gradient)"
							stroke="url(#strategy-gradient)"
							className="cls-1"
							d="M100.42,109.84h0c.86,0,1.57-.7,1.57-1.57l.07-22.36,6.38,6.38c.31.31.71.46,1.11.46s.8-.15,1.11-.46c.61-.61.61-1.61,0-2.22l-9.05-9.05s-.07-.04-.1-.06c-.12-.11-.26-.21-.41-.27-.16-.07-.34-.1-.52-.11-.03,0-.05-.02-.08-.02h0c-.2,0-.41.04-.6.12-.19.08-.37.19-.51.34,0,0,0,0,0,0l-9.05,9.05c-.61.61-.61,1.61,0,2.22s1.61.61,2.22,0l6.36-6.36-.07,22.33c0,.87.7,1.57,1.57,1.57Z"
						/>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							fill="url(#strategy-gradient)"
							stroke="url(#strategy-gradient)"
							className="cls-1"
							d="M137.47,97.22h0s-.01-.05-.02-.08c0-.18-.04-.35-.11-.52-.06-.16-.16-.29-.27-.41-.03-.03-.03-.07-.06-.09,0,0,0,0,0,0-.14-.14-.32-.26-.51-.34-.19-.08-.4-.12-.6-.12h-12.8c-.87,0-1.57.7-1.57,1.57s.7,1.57,1.57,1.57h8.99l-15.84,15.74c-.61.61-.62,1.6,0,2.22.31.31.71.46,1.11.46s.8-.15,1.11-.46l15.86-15.76v9.03c0,.87.7,1.57,1.57,1.57s1.57-.7,1.57-1.57v-12.8h0Z"
						/>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							fill="url(#strategy-gradient)"
							stroke="url(#strategy-gradient)"
							className="cls-1"
							d="M82.12,116.14c.31.31.71.46,1.11.46s.8-.15,1.11-.46c.61-.61.62-1.6,0-2.22l-15.76-15.86h9.03c.87,0,1.57-.7,1.57-1.57s-.7-1.57-1.57-1.57h-12.8s-.01,0-.02,0c-.2,0-.39.04-.58.12-.17.07-.33.18-.46.31-.01.01-.03.02-.05.03,0,0,0,0,0,0-.14.14-.26.32-.34.51s-.12.4-.12.6c0,0,0,0,0,0v12.8c0,.87.7,1.57,1.57,1.57s1.57-.7,1.57-1.57v-9l15.74,15.84Z"
						/>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							fill="url(#strategy-gradient)"
							stroke="url(#strategy-gradient)"
							className="cls-1"
							d="M100,70.17c10.05,0,18.23-8.18,18.23-18.23s-8.18-18.23-18.23-18.23-18.23,8.18-18.23,18.23,8.18,18.23,18.23,18.23ZM100,36.84c8.32,0,15.09,6.77,15.09,15.09s-6.77,15.09-15.09,15.09-15.09-6.77-15.09-15.09,6.77-15.09,15.09-15.09Z"
						/>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							fill="url(#strategy-gradient)"
							stroke="url(#strategy-gradient)"
							className="cls-1"
							d="M43.1,57.27c-4.87,0-9.45,1.9-12.89,5.34-7.11,7.11-7.11,18.68,0,25.78,3.44,3.44,8.02,5.34,12.89,5.34s9.45-1.9,12.89-5.34c7.11-7.11,7.11-18.68,0-25.78-3.44-3.44-8.02-5.34-12.89-5.34ZM32.43,86.18c-5.88-5.88-5.88-15.46,0-21.34,2.85-2.85,6.64-4.42,10.67-4.42s7.82,1.57,10.67,4.42c5.88,5.88,5.88,15.46,0,21.34-2.85,2.85-6.64,4.42-10.67,4.42s-7.82-1.57-10.67-4.42Z"
						/>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							fill="url(#strategy-gradient)"
							stroke="url(#strategy-gradient)"
							className="cls-1"
							d="M169.79,62.61c-3.44-3.44-8.02-5.34-12.89-5.34s-9.45,1.9-12.89,5.34c-7.11,7.11-7.11,18.68,0,25.78,3.44,3.44,8.02,5.34,12.89,5.34s9.45-1.9,12.89-5.34c7.11-7.11,7.11-18.68,0-25.78ZM156.9,90.6c-4.03,0-7.82-1.57-10.67-4.42-5.88-5.88-5.88-15.46,0-21.34,2.85-2.85,6.64-4.42,10.67-4.42s7.82,1.57,10.67,4.42c5.88,5.88,5.88,15.46,0,21.34-2.85,2.85-6.64,4.42-10.67,4.42Z"
						/>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							fill="url(#strategy-gradient)"
							stroke="url(#strategy-gradient)"
							className="cls-1"
							d="M164.1,69.94l-10.05,10.05-3.9-3.9c-.61-.61-1.61-.61-2.22,0s-.61,1.61,0,2.22l5.01,5.01c.29.29.69.46,1.11.46s.82-.17,1.11-.46l11.16-11.16c.61-.61.61-1.61,0-2.22s-1.61-.61-2.22,0Z"
						/>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							fill="url(#strategy-gradient)"
							stroke="url(#strategy-gradient)"
							className="cls-1"
							d="M93.47,58.46c.31.31.71.46,1.11.46s.8-.15,1.11-.46l4.31-4.31,4.31,4.31c.31.31.71.46,1.11.46s.8-.15,1.11-.46c.61-.61.61-1.61,0-2.22l-4.31-4.31,4.31-4.31c.61-.61.61-1.61,0-2.22s-1.61-.61-2.22,0l-4.31,4.31-4.31-4.31c-.61-.61-1.61-.61-2.22,0s-.61,1.61,0,2.22l4.31,4.31-4.31,4.31c-.61.61-.61,1.61,0,2.22Z"
						/>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							fill="url(#strategy-gradient)"
							stroke="url(#strategy-gradient)"
							className="cls-1"
							d="M49.63,68.98c-.61-.61-1.61-.61-2.22,0l-4.31,4.31-4.31-4.31c-.61-.61-1.61-.61-2.22,0s-.61,1.61,0,2.22l4.31,4.31-4.31,4.31c-.61.61-.61,1.61,0,2.22.31.31.71.46,1.11.46s.8-.15,1.11-.46l4.31-4.31,4.31,4.31c.31.31.71.46,1.11.46s.8-.15,1.11-.46c.61-.61.61-1.61,0-2.22l-4.31-4.31,4.31-4.31c.61-.61.61-1.61,0-2.22Z"
						/>
					</g>
					<defs>
						<linearGradient id="strategy-gradient" x1="0" y1="0" x2="200" y2="200" gradientUnits="userSpaceOnUse">
							<stop stopColor="#c3113c" /> <stop offset={1} stopColor="#c3113c" />
						</linearGradient>
						<clipPath id="strategy-clip-path">
							<rect width="200" height="200" fill="white" />
						</clipPath>
					</defs>
				</>
			),
			header: "Strategy",
			body: "We develop a custom strategy by<br />analyzing your goals and audience.<br />Our market research ensures<br />your campaign is unique and engaging.",
		},
		// Development
		{
			xPosition: 528,
			yPosition: 293,
			angle: 90,
			lineLength: 108,
			icon: (
				<>
					<g clipPath="url(##development-clip-path)">
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							fill="url(#development-gradient)"
							stroke="url(#development-gradient)"
							className="cls-1"
							d="M100,0C44.86,0,0,44.86,0,100s44.86,100,100,100,100-44.86,100-100S155.14,0,100,0ZM100,196.86c-53.41,0-96.86-43.45-96.86-96.86S46.59,3.14,100,3.14s96.86,43.45,96.86,96.86-43.45,96.86-96.86,96.86Z"
						/>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							fill="url(#development-gradient)"
							stroke="url(#development-gradient)"
							className="cls-1"
							d="M105.66,148.36c.66-.08,1.2-.56,1.35-1.21l2.83-12.53c2.66-.76,5.23-1.82,7.67-3.18l10.86,6.86c.56.36,1.29.32,1.81-.1,2.97-2.35,5.66-5.04,8.01-8.01.41-.52.45-1.25.1-1.81l-6.86-10.86c1.36-2.43,2.43-5,3.18-7.67l12.53-2.83c.65-.15,1.14-.69,1.21-1.35.22-1.93.34-3.84.34-5.66s-.11-3.73-.34-5.66c-.08-.66-.56-1.2-1.21-1.35l-12.53-2.83c-.76-2.66-1.82-5.23-3.18-7.67l6.86-10.86c.36-.56.32-1.29-.1-1.81-2.35-2.96-5.04-5.66-8.01-8.01-.52-.42-1.25-.45-1.81-.1l-10.86,6.86c-2.43-1.36-5-2.43-7.67-3.18l-2.83-12.53c-.15-.65-.69-1.14-1.35-1.21-3.9-.45-7.42-.45-11.32,0-.66.08-1.2.56-1.35,1.21l-2.83,12.53c-2.66.76-5.23,1.82-7.67,3.18l-10.86-6.86c-.56-.36-1.29-.32-1.81.1-2.97,2.35-5.66,5.04-8.01,8.01-.41.52-.45,1.25-.1,1.81l6.86,10.86c-1.36,2.43-2.43,5-3.18,7.67l-12.53,2.83c-.65.15-1.14.69-1.21,1.35-.22,1.93-.34,3.84-.34,5.66s.11,3.73.34,5.66c.08.66.56,1.2,1.21,1.35l12.53,2.83c.76,2.66,1.82,5.23,3.18,7.67l-6.86,10.86c-.36.56-.32,1.29.1,1.81,2.35,2.96,5.04,5.66,8.01,8.01.52.41,1.25.45,1.81.1l10.86-6.86c2.43,1.36,5,2.43,7.67,3.18l2.83,12.53c.15.65.69,1.14,1.35,1.21,1.97.23,3.82.34,5.66.34s3.72-.11,5.66-.34ZM93.01,133c-.13-.57-.57-1.03-1.14-1.17-3.01-.77-5.91-1.97-8.61-3.57-.51-.3-1.14-.29-1.64.02l-10.71,6.77c-2.16-1.79-4.15-3.78-5.94-5.94l6.76-10.71c.32-.5.32-1.13.02-1.64-1.6-2.7-2.81-5.6-3.57-8.61-.15-.57-.6-1.01-1.18-1.14l-12.35-2.79c-.13-1.44-.2-2.82-.2-4.2s.07-2.76.2-4.2l12.35-2.79c.58-.13,1.03-.57,1.18-1.14.77-3.02,1.97-5.91,3.57-8.61.3-.51.29-1.14-.02-1.64l-6.77-10.71c1.79-2.15,3.78-4.14,5.94-5.94l10.71,6.76c.5.31,1.13.32,1.64.02,2.7-1.6,5.6-2.81,8.61-3.57.57-.15,1.01-.6,1.14-1.17l2.79-12.36c2.88-.27,5.52-.27,8.4,0l2.79,12.36c.13.57.57,1.03,1.14,1.17,3.01.77,5.91,1.97,8.61,3.57.51.3,1.14.29,1.64-.02l10.71-6.76c2.16,1.8,4.15,3.79,5.94,5.94l-6.77,10.71c-.32.5-.32,1.13-.02,1.64,1.6,2.7,2.81,5.6,3.57,8.61.15.57.6,1.01,1.18,1.14l12.35,2.79c.13,1.43.2,2.84.2,4.2s-.07,2.76-.2,4.2l-12.35,2.79c-.58.13-1.03.57-1.18,1.14-.77,3.02-1.97,5.91-3.57,8.61-.3.51-.29,1.14.02,1.64l6.76,10.71c-1.79,2.15-3.78,4.14-5.94,5.94l-10.71-6.77c-.5-.31-1.13-.32-1.64-.02-2.7,1.6-5.6,2.81-8.61,3.57-.57.15-1.01.6-1.14,1.17l-2.79,12.36c-2.88.27-5.51.27-8.4,0l-2.79-12.36Z"
						/>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							fill="url(#development-gradient)"
							stroke="url(#development-gradient)"
							className="cls-1"
							d="M121.58,100c0-11.9-9.68-21.58-21.58-21.58s-21.58,9.68-21.58,21.58,9.68,21.58,21.58,21.58,21.58-9.68,21.58-21.58ZM100,118.44c-10.17,0-18.44-8.27-18.44-18.44s8.27-18.44,18.44-18.44,18.44,8.27,18.44,18.44-8.27,18.44-18.44,18.44Z"
						/>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							fill="url(#development-gradient)"
							stroke="url(#development-gradient)"
							className="cls-1"
							d="M150.94,45.61l6.88-10.91c.3-.47.32-1.07.06-1.57-.26-.5-.77-.82-1.33-.84l-28.16-1.09s-.02,0-.04,0c-.03,0-.05,0-.07,0-.19,0-.37.04-.54.11,0,0,0,0,0,0-.18.08-.35.18-.5.32,0,0-.01.01-.02.02-.08.08-.16.17-.22.27-.03.05-.05.11-.08.16-.01.02-.03.04-.04.06,0,.02,0,.04-.01.05-.07.17-.11.35-.11.53,0,.03,0,.06,0,.09,0,.15.04.3.09.44.02.04.03.09.05.13.01.03.02.06.03.09l13.13,24.92c.26.5.77.82,1.33.84.02,0,.04,0,.06,0,.54,0,1.04-.28,1.33-.73l6.45-10.23c13.88,13.22,22.12,31.74,22.12,51.68,0,39.35-32.01,71.36-71.36,71.36-.87,0-1.57.7-1.57,1.57s.7,1.57,1.57,1.57c41.08,0,74.5-33.42,74.5-74.5,0-21.04-8.79-40.56-23.56-54.39ZM130.99,34.46l22.72.88-12.13,19.24-10.59-20.11Z"
						/>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							fill="url(#development-gradient)"
							stroke="url(#development-gradient)"
							className="cls-1"
							d="M73.1,166.59s-.01-.05-.03-.07l-13.13-24.92c-.26-.5-.77-.82-1.33-.84-.57-.06-1.09.26-1.39.73l-6.44,10.21c-13.9-13.22-22.15-31.75-22.15-51.71,0-39.35,32.01-71.36,71.36-71.36.87,0,1.57-.7,1.57-1.57s-.7-1.57-1.57-1.57c-41.08,0-74.5,33.42-74.5,74.5,0,21.05,8.8,40.58,23.58,54.41l-6.88,10.92c-.3.47-.32,1.07-.06,1.57.26.5.77.82,1.33.84l28.16,1.09s.04,0,.06,0c.54,0,1.04-.28,1.33-.73.27-.43.3-.95.12-1.41-.01-.03-.02-.06-.03-.09ZM69.03,165.58l-22.72-.88,12.13-19.24,10.6,20.11Z"
						/>
					</g>
					<defs>
						<linearGradient id="development-gradient" x1="0" y1="0" x2="200" y2="200" gradientUnits="userSpaceOnUse">
							<stop stopColor="#c3113c" /> <stop offset={1} stopColor="#c3113c" />
						</linearGradient>
						<clipPath id="development-clip-path">
							<rect width="200" height="200" fill="white" />
						</clipPath>
					</defs>
				</>
			),
			header: "Development",
			body: "Our experienced developers create<br />interactive, user-friendly experiences<br />using the latest technology,<br />bringing your vision to life.",
			textAnchor: "middle",
			contentOffset: { x: 0, y: 44 },
		},
		// Art
		{
			xPosition: 1024,
			yPosition: 360,
			angle: 325,
			lineLength: 100,
			icon: (
				<>
					<g clipPath="url(#art-clip-path)">
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							fill="url(#art-gradient)"
							stroke="url(#art-gradient)"
							className="cls-1"
							d="M100,0C44.86,0,0,44.86,0,100s44.86,100,100,100,100-44.86,100-100S155.14,0,100,0ZM100,122.77c3.24,0,5.88,2.64,5.88,5.88s-2.64,5.88-5.88,5.88-5.88-2.64-5.88-5.88,2.64-5.88,5.88-5.88ZM98.43,119.78c-4.22.75-7.45,4.44-7.45,8.87,0,4.97,4.04,9.02,9.02,9.02s9.02-4.05,9.02-9.02c0-4.44-3.22-8.12-7.45-8.87v-28.28l24.5,42.87c-2.54,2.69-9.78,11.43-13.84,27.02h-24.46c-4.07-15.59-11.3-24.33-13.84-27.02l24.5-42.87v28.28ZM120.64,164.51c1.69,0,3.07,1.38,3.07,3.07v3.17c0,1.69-1.38,3.07-3.07,3.07h-41.28c-1.69,0-3.07-1.38-3.07-3.07v-3.17c0-1.69,1.38-3.07,3.07-3.07h41.28ZM117.49,176.95v18.29c-5.68,1.04-11.51,1.61-17.49,1.61s-11.81-.57-17.49-1.61v-18.29h34.97ZM120.63,194.63v-17.67h.02c3.42,0,6.21-2.78,6.21-6.21v-3.17c0-3.42-2.78-6.21-6.21-6.21h-5.16c4.7-17.22,13.51-25.52,13.61-25.6.54-.5.67-1.3.3-1.94l-28.03-49.03c-.05-.09-.12-.17-.19-.24-.29-.33-.7-.55-1.17-.55s-.88.22-1.17.55c-.07.08-.14.15-.19.24l-28.03,49.03c-.36.64-.24,1.44.3,1.94.09.08,8.91,8.38,13.61,25.6h-5.16c-3.42,0-6.21,2.78-6.21,6.21v3.17c0,3.42,2.78,6.21,6.21,6.21h.02v17.67C35.84,185.15,3.14,146.33,3.14,100,3.14,46.59,46.59,3.14,100,3.14s96.86,43.45,96.86,96.86c0,46.33-32.7,85.15-76.24,94.63Z"
						/>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							fill="url(#art-gradient)"
							stroke="url(#art-gradient)"
							className="cls-1"
							d="M156.77,72.3h18.51c.87,0,1.57-.7,1.57-1.57v-18.51c0-.87-.7-1.57-1.57-1.57h-18.51c-.87,0-1.57.7-1.57,1.57v7.69h-44.37v-7.69c0-.87-.7-1.57-1.57-1.57h-18.51c-.87,0-1.57.7-1.57,1.57v7.69h-44.37v-7.69c0-.87-.7-1.57-1.57-1.57h-18.51c-.87,0-1.57.7-1.57,1.57v18.51c0,.87.7,1.57,1.57,1.57h18.51c.87,0,1.57-.7,1.57-1.57v-7.69h34.84c-26.88,8.51-46.52,33.39-47.2,62.89h-7.73c-.87,0-1.57.7-1.57,1.57v18.51c0,.87.7,1.57,1.57,1.57h18.51c.87,0,1.57-.7,1.57-1.57v-18.51c0-.87-.7-1.57-1.57-1.57h-7.65c.75-31.15,23.69-56.88,53.59-61.96v6.76c0,.87.7,1.57,1.57,1.57h18.51c.87,0,1.57-.7,1.57-1.57v-6.76c29.9,5.08,52.84,30.81,53.59,61.96h-7.65c-.87,0-1.57.7-1.57,1.57v18.51c0,.87.7,1.57,1.57,1.57h18.51c.87,0,1.57-.7,1.57-1.57v-18.51c0-.87-.7-1.57-1.57-1.57h-7.73c-.68-29.49-20.32-54.38-47.2-62.89h34.84v7.69c0,.87.7,1.57,1.57,1.57ZM26.29,53.79h15.37v6.99c-.11.21-.18.44-.18.69s.07.48.18.69v6.99h-15.37v-15.37ZM41.66,144.45h-15.37v-15.37h15.37v15.37ZM173.71,144.45h-15.37v-15.37h15.37v15.37ZM92.31,69.16v-15.37h15.37v15.37h-15.37ZM173.71,69.16h-15.37v-6.99c.11-.21.18-.44.18-.69s-.07-.48-.18-.69v-6.99h15.37v15.37Z"
						/>
					</g>
					<defs>
						<linearGradient id="art-gradient" x1="0" y1="0" x2="200" y2="200" gradientUnits="userSpaceOnUse">
							<stop stopColor="#c3113c" /> <stop offset={1} stopColor="#c3113c" />
						</linearGradient>
						<clipPath id="art-clip-path">
							<rect width="200" height="200" fill="white" />
						</clipPath>
					</defs>
				</>
			),
			header: "Art",
			body: "Our creative team works with you<br />to create visually stunning content<br />that enhances user engagement<br />and strengthens your brand.",
		},
		// Deployment
		{
			xPosition: 1652,
			yPosition: 600,
			angle: 220,
			lineLength: 100,
			icon: (
				<>
					<g clipPath="url(#deployment-clip-path)">
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							fill="url(#deployment-gradient)"
							stroke="url(#deployment-gradient)"
							className="cls-1"
							d="M100,0C44.86,0,0,44.86,0,100s44.86,100,100,100,100-44.86,100-100S155.14,0,100,0ZM100,196.86c-53.41,0-96.86-43.45-96.86-96.86S46.59,3.14,100,3.14s96.86,43.45,96.86,96.86-43.45,96.86-96.86,96.86Z"
						/>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							fill="url(#deployment-gradient)"
							stroke="url(#deployment-gradient)"
							className="cls-1"
							d="M154.15,46.9c-.15-.51-.55-.91-1.06-1.06-.24-.07-15.17-4.32-33.54-.14-.29-.02-.58.06-.84.2-10.59,2.54-22.26,7.92-32.87,18.53-3.87,3.87-7.37,7.97-10.45,12.19-21.63,2.7-28.64,4.84-54.41,32.79-.5.54-.55,1.37-.13,1.97.3.43.78.66,1.28.66.21,0,.42-.04.62-.13,18.55-7.95,25.27-7.1,38.78-4.77l-1.24,6.56c-.1.51.07,1.03.43,1.4l24.16,24.16c.3.3.7.46,1.11.46.1,0,.19,0,.29-.03l6.56-1.24c2.33,13.51,3.18,20.22-4.77,38.78-.29.68-.07,1.47.54,1.9.27.19.59.29.91.29.38,0,.77-.14,1.06-.42,27.95-25.78,30.08-32.78,32.79-54.41,4.22-3.08,8.32-6.58,12.19-10.45,10.61-10.61,15.98-22.28,18.53-32.87.15-.26.22-.54.2-.84,4.18-18.37-.08-33.3-.15-33.54ZM93.6,171.9c5.44-14.76,4.42-21.96,2.33-34.08,7.83-1.81,16.05-5.55,23.97-10.81-2.34,17.63-5.04,24.72-26.3,44.89ZM62.18,104.07c-12.12-2.09-19.32-3.11-34.08,2.33,20.17-21.26,27.26-23.96,44.89-26.3-5.26,7.92-9,16.15-10.81,23.97ZM64.37,109.08l26.55,26.55-4.39.83-22.98-22.98.83-4.39ZM94.64,134.91l-29.55-29.55c2.8-12.8,11.13-26.86,22.98-38.71,10-10,20.97-15.13,30.97-17.61l31.91,31.91c-2.48,10-7.61,20.98-17.6,30.97-11.85,11.85-25.9,20.18-38.71,22.98ZM151.36,48.64c.75,3.14,3.07,14.65.4,28.68l-29.08-29.08c14.04-2.67,25.55-.36,28.68.4Z"
						/>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							fill="url(#deployment-gradient)"
							stroke="url(#deployment-gradient)"
							className="cls-1"
							d="M106.21,74.8c-5.24,5.24-5.24,13.76,0,18.99,2.62,2.62,6.06,3.93,9.5,3.93s6.88-1.31,9.5-3.93c5.24-5.24,5.24-13.76,0-18.99s-13.76-5.24-18.99,0ZM108.42,91.58c-4.01-4.01-4.01-10.54,0-14.55,1.94-1.94,4.53-3.02,7.28-3.02s5.33,1.07,7.28,3.02c4.01,4.01,4.01,10.54,0,14.55-4.01,4.01-10.54,4.01-14.55,0Z"
						/>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							fill="url(#deployment-gradient)"
							stroke="url(#deployment-gradient)"
							className="cls-1"
							d="M45.65,141.47l12.7-12.7c.61-.61.61-1.61,0-2.22s-1.61-.61-2.22,0l-12.7,12.7c-.61.61-.61,1.61,0,2.22.31.31.71.46,1.11.46s.8-.15,1.11-.46Z"
						/>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							fill="url(#deployment-gradient)"
							stroke="url(#deployment-gradient)"
							className="cls-1"
							d="M65.9,134.1c-.61-.61-1.61-.61-2.22,0l-24.53,24.53c-.61.61-.61,1.61,0,2.22.31.31.71.46,1.11.46s.8-.15,1.11-.46l24.53-24.53c.61-.61.61-1.61,0-2.22Z"
						/>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							fill="url(#deployment-gradient)"
							stroke="url(#deployment-gradient)"
							className="cls-1"
							d="M71.23,141.65l-17.6,17.6c-.61.61-.61,1.61,0,2.22.31.31.71.46,1.11.46s.8-.15,1.11-.46l17.6-17.6c.61-.61.61-1.61,0-2.22s-1.61-.61-2.22,0Z"
						/>
					</g>
					<defs>
						<linearGradient id="deployment-gradient" x1="0" y1="0" x2="200" y2="200" gradientUnits="userSpaceOnUse">
							<stop stopColor="#c3113c" /> <stop offset={1} stopColor="#c3113c" />
						</linearGradient>
						<clipPath id="deployment-clip-path">
							<rect width="200" height="200" fill="white" />
						</clipPath>
					</defs>
				</>
			),
			header: "Deployment",
			body: "We handle the complete<br />deployment process,<br />ensuring a smooth launch<br />and optimal performance.",
			textAnchor: "end",
			contentOffset: { x: -8, y: -4 },
		},
	],
};
